import React, { useEffect } from 'react';
import './Toast.css';
import { Spinner } from '../Spinner/Spinner';

export const Toast = ({ 
  message, 
  onClose, 
  showSpinner = false, 
  duration = 2000 // default duration
}) => {
  useEffect(() => {
    // Only set timeout if not showing spinner
    if (!showSpinner) {
      const timer = setTimeout(() => {
        onClose();
      }, 1500);

      // Cleanup timer on unmount
      return () => clearTimeout(timer);
    }
  }, [duration, onClose, showSpinner]);

  return (
    <div className="toast-container">
      <div className="toast">
        {showSpinner && <Spinner size="small" />}
        <span className="toast-message">{message}</span>
      </div>
    </div>
  );
}; 